






















import Vue from 'vue'
import * as echarts from 'echarts'
import EchartsRhu from './EchartsRhu'
export default Vue.extend({
  props: {
    data: { type: Array },
    typeStr: { type: String }
  },
  watch: {
    data(val) {
      this.echarts()
    }
  },
  mounted() {
    this.echarts()
  },
  data() {
    return {
      isFull: false
    }
  },
  methods: {
    echarts() {
      const dom: any = document.getElementById('echartsRhu')
      const myChart: any = echarts.init(dom) // 基于准备好的dom，初始化echarts实例
      window.onresize = myChart.resize;  // 图表宽度自适应
      const chartData = this.data

      //@ts-ignore
      myChart.setOption(EchartsRhu(chartData,''))
    },
    fullScreen() {
      this.isFull = true;
      let fullEchart = document.getElementById('rhuFull');
      const myChart: any = echarts.init(fullEchart) // 基于准备好的dom，初始化echarts实例
      window.onresize = myChart.resize;  // 图表宽度自适应
      //@ts-ignore
      myChart.setOption(EchartsRhu(this.data,'full'))
    },
    exitFullScreen() {
      this.isFull = false
    }
  }
})
